import { render, staticRenderFns } from "./ProductDesktop.vue?vue&type=template&id=6788cb80&scoped=true&"
import script from "./ProductDesktop.vue?vue&type=script&lang=js&"
export * from "./ProductDesktop.vue?vue&type=script&lang=js&"
import style0 from "./ProductDesktop.vue?vue&type=style&index=0&id=6788cb80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6788cb80",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VImg,VRow})
